// src/components/wizard/WizardStep.js
import React from "react";
import { useWizard } from "./WizardContext";
import CustomStepper from "./CustomStepper";
import { Box } from "@mui/material";

export default function WizardStep({
  index,
  children,
  isStepperNavigationAllowed = true,
}) {
  const { steps, current, back, stepsConfig } = useWizard();

  // only show this block when it’s the active step
  if (current !== index) {
    return null;
  }

  return (
    <Box>
      {/* show the CustomStepper at the top */}
      <CustomStepper
        back={back}
        steps={steps}
        currentStep={current}
        stepsConfig={stepsConfig}
        isStepperNavigationAllowed={isStepperNavigationAllowed}
      />
      {/* step content */}
      <Box mt={2}>{children}</Box>
    </Box>
  );
}
